import { type TFunction } from 'i18next';
import { SearchableFieldType } from '../../ISearchableField.tsx';

/**
 * Ritorna l'etichetta breve del tipo di un `SearchableField`, mostrata accanto
 * alla `label` nello step "pick" del `FilterBarAddPopover` (es. "testo",
 * "lista", "intervallo date"). Default `''` per tipi sconosciuti.
 */
export function getSearchableFieldTypeLabel(
  type: SearchableFieldType,
  t: TFunction,
): string {
  switch (type) {
    case SearchableFieldType.Text:
      return t('filter-bar.field-type.text', 'testo');
    case SearchableFieldType.Number:
      return t('filter-bar.field-type.number', 'numero');
    case SearchableFieldType.Date:
      return t('filter-bar.field-type.date', 'data');
    case SearchableFieldType.DateRange:
      return t('filter-bar.field-type.date-range', 'intervallo date');
    case SearchableFieldType.NumberRange:
      return t('filter-bar.field-type.number-range', 'intervallo numerico');
    case SearchableFieldType.Select:
      return t('filter-bar.field-type.select', 'lista');
    case SearchableFieldType.Radio:
      return t('filter-bar.field-type.radio', 'lista');
    case SearchableFieldType.Custom:
      return t('filter-bar.field-type.custom', 'lista');
    case SearchableFieldType.Switch:
      return t('filter-bar.field-type.switch', 'booleano');
    default:
      return '';
  }
}
